export type PgsPaymentMethod = {
  code: string;
  title: string;
  description: string;
  icon: string;
  tokenizable: boolean;
  enabled: boolean;
};

export type PaymentData = {
  amount: string;
  currency: string;
  order_id: number;
  payment_method: string;
  payment_token: string;
  status: string;
  errors?: string[];
  method?: {
    title?: string;
    icon?: string;
  };
  title?: string;
  icon?: string;
};

export type PgsOrderInput = {
  orderId: string;
  customer: {
    uuid: string;
  };
  tokenize_payment?: boolean;
};

export type GetPaymentMethodsOptions = {
  skus?: string[];
};

type CreatePaymentSessionResult = {
  session_id: string;
  merchant: string;
};

export type ProcessSecuredFieldsPaymentInput = {
  sessionId: string;
  orderId: number;
  consumerId: string;
  paymentMethod: string;
  tokenize: boolean;
};

export interface PgsApiContract {
  placeOrder(order: PgsOrderInput): Promise<string>;
  getPaymentMethods(options?: GetPaymentMethodsOptions): Promise<{ data: PgsPaymentMethod[] }>;
  getClient(code: string, locale?: string): Promise<string>;
  getOrderPaymentMethod(paymentToken: string): Promise<PaymentData>;
  createPaymentSession?(paymentMethod: string): Promise<CreatePaymentSessionResult>;
  processSecuredFieldsPayment?(input: ProcessSecuredFieldsPaymentInput): Promise<PaymentData>;
}
